if (!customElements.get('combo-image-slider')) {
  customElements.define('combo-image-slider', class extends HTMLElement {
    connectedCallback() {
      // Defer execution to ensure children are parsed
      setTimeout(() => {
        this.images = this.querySelectorAll('.combo-image');
        this.dots = this.querySelectorAll('.combo-dot');
        this.prevBtn = this.querySelector('.combo-nav-btn.prev');
        this.nextBtn = this.querySelector('.combo-nav-btn.next');
        this.currentIndex = 0;
        
        if (this.images.length <= 1) return;
        
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showImage(this.currentIndex - 1);
          });
        }
        
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showImage(this.currentIndex + 1);
          });
        }
        
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            this.showImage(index);
          });
        });
      }, 0);
    }
    
    showImage(index) {
      if (index < 0) {
        index = this.images.length - 1;
      } else if (index >= this.images.length) {
        index = 0;
      }
      
      this.images[this.currentIndex].classList.remove('active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('active');
      }
      
      this.currentIndex = index;
      
      this.images[this.currentIndex].classList.add('active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('active');
      }
    }
  });
}
